import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Step } from '@qtek/shared/models';

export const WizardActions = createActionGroup({
  source: 'Wizard',
  events: {
    'Is Wizard Done': emptyProps(),
    'Get Steps': emptyProps(),
    'Get Steps Success': props<{ payload: Step[] }>(),
    'Set Max Person Progress': props<{ payload: number }>(),
    'Set Max Company Progress': props<{ payload: number }>(),
    'Step Prs 1': props<{ personId: string; payload: any }>(),
    'Step Prs 2': props<{ personId: string; payload: any }>(),
    'Step Cmp 2048': props<{ companyId: string; payload: any }>(),
    'Set Loading': props<{ payload: boolean }>(),
    'Step Success': emptyProps(),
    'Step Failure': emptyProps(),
  },
});
